/* ==========================================================
   PDP Upsell — abrir drawer primeiro, add ao carrinho e
   atualizar apenas o conteúdo do minicart (sem reload)
   ========================================================== */

const MINICART_SECTION_ID = 'minicart-form';  // do seu HTML
const MINICART_FORM_SEL   = '#minicart-form';

/* ---------------- helpers ---------------- */
const $  = (s, r=document) => r.querySelector(s);
const $$ = (s, r=document) => [...r.querySelectorAll(s)];

function getCartComponent() {
  return document.querySelector('cart-drawer') || document.querySelector('cart-notification') || null;
}

function openCart() {
  const cart = getCartComponent();
  if (cart?.open) cart.open();
}

/** Espera um seletor aparecer no DOM usando MutationObserver (sem timeouts) */
function waitForEl(selector) {
  return new Promise((resolve) => {
    const found = $(selector);
    if (found) return resolve(found);
    const obs = new MutationObserver(() => {
      const el = $(selector);
      if (el) { obs.disconnect(); resolve(el); }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  });
}

/** Adiciona item com /cart/add.js (simples, sem sections) */
async function addToCart(variantId, qty = 1, properties) {
  const item = { id: Number(variantId), quantity: Number(qty) };
  if (properties && typeof properties === 'object') item.properties = properties;

  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: [item] })
  });
  const txt = await res.text();
  if (!res.ok) throw new Error(txt || 'Falha ao adicionar');
  try { return JSON.parse(txt); } catch { return txt; }
}

/** Puxa o HTML da section correta e substitui só o #minicart-form (como no seu snippet) */
async function refreshMiniCart() {
  const res = await fetch(`/cart?section_id=${MINICART_SECTION_ID}`, { headers: { 'Accept': 'text/html' } });
  if (!res.ok) throw new Error('Falha ao buscar section do minicart');
  const htmlString = await res.text();
  const doc = new DOMParser().parseFromString(htmlString, 'text/html');

  const incoming = $(MINICART_FORM_SEL, doc);
  const target   = $(MINICART_FORM_SEL, document);
  if (incoming && target) {
    target.innerHTML = incoming.innerHTML;
  } else {
    console.warn('[pdp-upsell] #minicart-form não encontrado para substituir.');
  }
}

/** Atualiza contadores no header (cart-count etc.) */
async function refreshCartCount() {
  try {
    const json = await (await fetch('/cart.json', { headers: { 'Accept': 'application/json' } })).json();
    const count = json.cart?.item_count ?? json.item_count ?? 0;
    $$('.cart-count').forEach(el => { el.textContent = count > 100 ? '~' : count; });
  } catch (e) {
    console.debug('[pdp-upsell] refreshCartCount falhou (ok):', e);
  }
}

/* --------------- sincronização do select de variantes --------------- */
/* Quando o usuário escolhe uma variante no .upsell-variants, atualizamos
   preço, compare-at, imagem, disponibilidade e o data-variant-id do botão.
   O fluxo de adicionar ao carrinho continua sendo o handler de click abaixo. */
document.addEventListener('change', (e) => {
  const sel = e.target.closest('.upsell-variants');
  if (!sel) return;

  const root = sel.closest('.upsell-inline');
  const opt  = sel.options[sel.selectedIndex];
  if (!root || !opt) return;

  // Preço
  const priceEl = $('.upsell-price', root);
  if (priceEl) priceEl.textContent = opt.dataset.price || '';

  // Compare-at (preço riscado)
  const compareEl = $('.upsell-compare', root);
  if (compareEl) {
    if (opt.dataset.compare) {
      compareEl.textContent = opt.dataset.compare;
      compareEl.hidden = false;
    } else {
      compareEl.textContent = '';
      compareEl.hidden = true;
    }
  }

  // Imagem da variante
  const img = $('.upsell-media img', root);
  if (img && opt.dataset.image) {
    img.src = opt.dataset.image;
    if (opt.dataset.imageSrcset) img.srcset = opt.dataset.imageSrcset;
  }

  // Disponibilidade → botão + linha "Sem estoque"
  const available = opt.dataset.available === 'true';
  const btn = $('.upsell-add', root);
  if (btn) {
    btn.dataset.variantId = opt.value;   // <-- o handler de click abaixo lê isso
    btn.disabled = !available;
    if (available) btn.removeAttribute('aria-disabled');
    else btn.setAttribute('aria-disabled', 'true');
  }

  const oosEl = $('.upsell-oos', root);
  if (oosEl) oosEl.hidden = available;
});

/* --------------- fluxo do upsell --------------- */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.upsell-add');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const variantId = btn.dataset.variantId;
  const qty = Number(btn.dataset.qty || 1);

  // evita submit de form ancestral
  const form = btn.closest('form');
  if (form) form.addEventListener('submit', ev => ev.preventDefault(), { once: true });

  // feedback
  const original = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Adicionando…';

  try {
    // 1) abre o drawer PRIMEIRO (seu tema só cria o #minicart-form depois que abre)
    openCart();

    // 2) espera o container existir
    await waitForEl(MINICART_FORM_SEL);

    // 3) adiciona ao carrinho
    await addToCart(variantId, qty);

    // 4) atualiza apenas o conteúdo do minicart
    await refreshMiniCart();

    // 5) atualiza contadores/badge
    await refreshCartCount();

    // evento opcional para analytics
    document.dispatchEvent(new CustomEvent('upsell:add', { detail: { variantId, qty, source: 'pdp-inline' }}));

    btn.textContent = 'Adicionado!';
  } catch (err) {
    console.error('[pdp-upsell] erro:', err);
    btn.textContent = 'Tentar de novo';
  } finally {
    setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 900);
  }
});

/* --------------- impedir navegação pra /cart --------------- */
/* Se o usuário clicar no ícone do carrinho, abrimos o drawer ao invés de navegar */
// document.addEventListener('click', (e) => {
//   const a = e.target.closest('a[href="/cart"], a[href^="/cart?"], #cart-icon-bubble');
//   if (!a) return;
//   if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;

//   e.preventDefault();
//   // neutraliza o href (opcional)
//   if (a.getAttribute('href') === '/cart') a.setAttribute('href', '#cart');
//   openCart();
// }, { capture: true });

/* Requisito do HTML do snippet upsell-inline.liquid:
   - .upsell-inline                 → wrapper
   - .upsell-media img              → imagem da variante
   - .upsell-variants               → <select> de variantes (omitido se single-variant)
       options com data-price, data-compare, data-image, data-image-srcset, data-available
   - .upsell-price                  → preço atual
   - .upsell-compare                → preço riscado (hidden quando não houver)
   - .upsell-oos                    → linha "Sem estoque" (hidden quando disponível)
   - .upsell-add                    → botão "+ Adicionar"
       data-variant-id (atualizado pelo change handler), data-qty
*/